import { createSlice } from '@reduxjs/toolkit';

const categorySlice = createSlice({

    name: 'category',
    initialState: [],

    reducers: {
        setCategory: (state, action) => {
            state = action.payload;
            return state;
        },
    },
});

export default categorySlice;